export default __webpack_public_path__ + "static/media/brandontext-medium.4eda5931.ttf";